import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {percentage} from '../../core/mathz'
import {sanitize} from '../../core/extract'
import DashboardPanel from '../../core/components/DashboardPanel'
import i18n from '../i18n'
import style from './ClosingRateDashboardPanel.less'

class ClosingRateDashboardPanel extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, aggregations, ...others} = this.props

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        const closingRate = percentage({
            source: aggregations.status,
            identify: (s) => s.count,
            match: (s) => sanitize(s.value) == 'closed'
        })

        return (
            <DashboardPanel
                header={panelHeader(i18n.closingRate)}
                {...others}>
                <div className={style.closingRate}>
                    <p>{i18n.aboutClosingRate}</p>
                    {!isNaN(closingRate) && (
                        <span className={style.rate}>{closingRate} %</span>
                    )}
                </div>
            </DashboardPanel>
        )
    }
}

ClosingRateDashboardPanel = connect((state) => ({
	aggregations: state.ticket.aggregations
}))(ClosingRateDashboardPanel)

export default ClosingRateDashboardPanel


// WEBPACK FOOTER //
// ./lib/ticket/components/ClosingRateDashboardPanel.js